<template>
  <Transition :name="isMobile ? 'fade-absolute' : 'slide-from-top'">
    <div
      v-if="shouldRender"
      v-show="visible"
      class="absolute top-0 w-full tablet:mt-4 page-menu-popup z-500 tablet:shadow-xl tablet:rounded-md tablet:w-[500px] bg-background tablet:bg-scheme-main tablet:right-0"
    >
      <slot />
    </div>
  </Transition>
</template>

<script setup lang="ts">
const props = defineProps<{
  visible: boolean
}>()

const { isMobile } = useViewport()

// Whether the popup content should be rendered in the DOM.
// This is so that once the popup has been opened at least once we only hide
// it instead of removing it.
const shouldRender = ref(false)

watch(
  () => props.visible,
  (isOpen) => {
    // Render the popup in the DOM once it becomes open.
    if (isOpen) {
      shouldRender.value = true
    }
  },
)
</script>

<style lang="postcss">
.page-menu-popup {
  @screen tablet {
    top: calc(var(--page-menu-top) + var(--page-menu-bottom));
    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
  }
}
</style>
